module.exports = __webpack_public_path__ + "static/mr-press-06-ef8aa2cb9ef249df472d91170b87c265.jpg";